import React from "react";
import { useSelector } from "react-redux";
import { useScreenshotProtection } from "../../hooks/useScreenshotProtection";
import ScreenshotBlockOverlay from "./ScreenshotBlockOverlay";
import "./ScreenshotProtection.css";

const ScreenshotProtectionGate = ({ children }) => {
  const presentMode = useSelector((state) => state.slide.presentMode);
  const { isBlocked, dismissBlock } = useScreenshotProtection({
    suppressFocusLossBlocking: presentMode,
  });

  return (
    <>
      <div className={`screenshot-protected-content ${isBlocked ? "is-blocked" : ""}`}>
        {children}
      </div>
      <ScreenshotBlockOverlay isVisible={isBlocked} onClose={dismissBlock} />
    </>
  );
};

export default ScreenshotProtectionGate;
